import { addBreadcrumb, captureException } from "@sentry/react";
import { shouldIgnoreSentryErrorMessage } from "./filters";

export const overrideConsoleToRemoteLog = (): void => {
  // Override console.log to sentry
  console.log = (...args): void => {
    addBreadcrumb({
      category: "LOG",
      message: args.join(" "),
      level: "log",
    });
  };

  console.info = (...args): void => {
    addBreadcrumb({
      category: "LOG",
      message: args.join(" "),
      level: "info",
    });
  };

  console.warn = (...args): void => {
    addBreadcrumb({
      category: "LOG",
      message: args.join(" "),
      level: "warning",
    });
  };

  // Override console.error to sentry
  console.error = (error) => {
    const message =
      error instanceof Error
        ? error.message
        : typeof error === "string"
          ? error
          : JSON.stringify(error);
    if (shouldIgnoreSentryErrorMessage(message)) {
      return;
    }

    if (error instanceof Error) {
      captureException(error);
    } else if (typeof error === "string") {
      captureException(new Error(error));
    } else {
      captureException(new Error(JSON.stringify(error)));
    }
  };
};
